export const OPEN_CREATE_NEW_STRATEGY_VERSION_POP_UP = 'OPEN_CREATE_NEW_STRATEGY_VERSION_POP_UP';
export const CLOSE_CREATE_NEW_STRATEGY_VERSION_POP_UP = 'CLOSE_CREATE_NEW_STRATEGY_VERSION_POP_UP';
export const CREATE_NEW_STRATEGY_VERSION_REQUEST = 'CREATE_NEW_STRATEGY_VERSION_REQUEST';
export const CREATE_NEW_STRATEGY_VERSION_REQUEST_SUCCESS = 'CREATE_NEW_STRATEGY_VERSION_REQUEST_SUCCESS';
export const CREATE_NEW_STRATEGY_VERSION_REQUEST_FAILURE = 'CREATE_NEW_STRATEGY_VERSION_REQUEST_FAILURE';
